import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BaseIcon } from '../../../components/base-icon.mjs';

const SvgUserEdit = forwardRef((props, ref) => /* @__PURE__ */ jsx(BaseIcon, { fill: "currentColor", ref, ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    d: "M5 8a4 4 0 1 1 7.796 1.263l-2.533 2.534A4 4 0 0 1 5 8m4.06 5H7a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h2.172a3 3 0 0 1-.114-1.588l.674-3.372a3 3 0 0 1 .82-1.533zm9.032-5a2.9 2.9 0 0 0-2.056.852L9.967 14.92a1 1 0 0 0-.273.51l-.675 3.373a1 1 0 0 0 1.177 1.177l3.372-.675a1 1 0 0 0 .511-.273l6.07-6.07a2.91 2.91 0 0 0-.944-4.742A2.9 2.9 0 0 0 18.092 8",
    clipRule: "evenodd"
  }
) }));

export { SvgUserEdit as default };
//# sourceMappingURL=user-edit.mjs.map
